export default "__VITE_ASSET__ab59e3d1__"